module.exports = __webpack_public_path__ + "img/gp_main02_text.91fe2251.svg";